/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Cmdk_UpdatedInputs */

const en_cmdk_updated = /** @type {(inputs: Cmdk_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.time}`)
};

const es_cmdk_updated = /** @type {(inputs: Cmdk_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actualizado ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Updated {time}" |
*
* @param {Cmdk_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cmdk_updated = /** @type {((inputs: Cmdk_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmdk_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_cmdk_updated(inputs)
	return en_cmdk_updated(inputs)
});